import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/icons/imaging-accreditation/cdc_copy_new.png";
import FaxIcon from "@mui/icons-material/Fax";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PlaceIcon from "@mui/icons-material/Place";
import PaymentIcon from "@mui/icons-material/Payment";
export default function MainFooter() {
  return (
    <footer className="bg-black border-t border-[#141414]">
      <div className="px-6 sm:px-10 lg:px-20 pt-14 pb-14 lg:pb-0 lg:pt-20">
        {/* ================= TOP SECTION ================= */}
        <div className="flex flex-col xl:flex-row gap-14 xl:gap-0 justify-between">
          {/* LEFT */}
          <div className="text-center xl:text-left">
            <div className="xl:w-[80%]">
              <div className="flex xl:justify-start justify-center flex-row gap-8 w-full">
                {/* LEFT COLUMN */}
                <div className="flex flex-col gap-8 md:w-80 xl:w-56 w-1/2">
                  {/* Office */}
                  <div className="flex flex-col md:justify-start justify-center gap-2">
                    <p className="flex gap-2 items-center justify-center xl:justify-start">
                      <LocalPhoneIcon sx={{ color: "#ccc" }} />
                      <span className="text-[#7a7a7a] text-[16px] font-robout">
                        Office
                      </span>
                    </p>
                    <p>
                      <a
                        href="tel:3527959200"
                        className="hover:underline text-white py-3 text-[16px] font-robout leading-relaxed whitespace-nowrap"
                      >
                        (352) 795-9200
                      </a>
                    </p>
                  </div>

                  {/* Billing */}
                  <div className="flex flex-col md:justify-start justify-center gap-2">
                    <p className="flex gap-2 items-center justify-center xl:justify-start">
                      <PaymentIcon sx={{ color: "#ccc" }} />
                      <span className="text-[#7a7a7a] text-[16px] font-robout">
                        Billing
                      </span>
                    </p>
                    <p>
                      <a
                        href="tel:3524508062"
                        className="hover:underline text-white py-3 text-[16px] font-robout leading-relaxed whitespace-nowrap"
                      >
                        (352) 450-8062
                      </a>
                    </p>
                  </div>
                </div>

                {/* DIVIDER */}
                <div className="hidden md:block w-px bg-[#ccc]"></div>

                {/* RIGHT COLUMN */}
                <div className="flex flex-col gap-8 w-1/2 md:w-80 xl:w-full">
                  {/* Fax */}
                  <div className="flex flex-col md:justify-start justify-center gap-2 md:ps-10">
                    <p className="flex gap-2 items-center justify-center xl:justify-start">
                      <FaxIcon sx={{ color: "#ccc" }} />
                      <span className="text-[#7a7a7a] text-[16px] font-robout">
                        Fax
                      </span>
                    </p>
                    <p>
                      <a
                        href="tel:3527956460"
                        className="hover:underline text-white py-3 text-[16px] font-robout leading-relaxed whitespace-nowrap"
                      >
                        (352) 795-6460
                      </a>
                    </p>
                  </div>

                  {/* Address */}
                  <div className="flex md:justify-start justify-center flex-col gap-2 md:ps-10">
                    <p className="flex gap-2 items-center justify-center xl:justify-start">
                      <PlaceIcon sx={{ color: "#ccc" }} />
                      <span className="text-[#7a7a7a] text-[16px] font-robout">
                        Visit
                      </span>
                    </p>
                    <p>
                      <Link
                        to="https://maps.app.goo.gl/MQ5H5FsCB4nBt8dy7"
                        target="_blank"
                        aria-label="Address"
                        className="hover:underline text-white text-[14px] sm:text-[16px]"
                      >
                        <span className="block whitespace-nowrap">
                          922 N Citrus Ave,
                        </span>
                        <span className="block whitespace-nowrap">
                          Crystal River, FL 34428
                        </span>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT */}
          <div className="flex flex-col items-center text-center">
            <Link to="/" aria-label="Citrus Diagnostic Center - Home">
              <img
                src={Logo}
                alt="Citrus Diagnostic Center"
                className="w-[200px] sm:w-[250px] h-auto"
              />
            </Link>
          </div>
        </div>

        {/* ================= BOTTOM SECTION ================= */}
        <div className="flex flex-col-reverse md:flex-row gap-6 md:gap-0 justify-between items-center pt-4 pb-12 text-center md:text-left">
          {/* LINKS */}
          <div className="flex flex-wrap gap-x-5 gap-y-3 justify-center md:justify-start text-[#7a7a7a] font-robout text-[15px]">
            <Link className="hover:text-white" to="/medical-privacy-policy">
              Privacy Policy
            </Link>
            <Link
              className="hover:text-white"
              to="/notice-of-privacy-practices"
            >
              Notice of Privacy Practices
            </Link>
            <Link className="hover:text-white" to="/terms-of-use">
              Terms of Use
            </Link>
            <Link className="hover:text-white" to="/accessibility-statement">
              Accessibility
            </Link>
            <Link className="hover:text-white" to="/patient-bill-of-rights">
             Florida Patient Bill of Rights
            </Link>
           
            <Link className="hover:text-white" to="/siteMap">
              Sitemap
            </Link>
          </div>

          <div>
            {/* COPYRIGHT */}
            <p className="text-[#7a7a7a] text-[15px]">
              © 2026 Citrus Diagnostic Center.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
